import { useCallback, useState } from 'react';

/**
 * Returns a function that forces the component to re-render.
 * @returns {Function} forceUpdate
 */
const useForceUpdate = (): (() => void) => {
  const [, setState] = useState({});
  return useCallback(() => {
    setState({});
  }, []);
};

export default useForceUpdate;
